import { formatDate } from 'src/utils/formatDate';
import { QuestionTemplateGetAttributes } from 'src/models/QuestionTemplateModel';
export interface QuestionCategoryContainQuestionTemplatesAttributes {
  category_id: string;
  category_name: string;
  category_icon: string;
  question_templates: QuestionTemplateGetAttributes[];
}
export interface QuestionCategorySendAttributes {
  name: string;
  icon?: string;
}
export interface QuestionCategoryGetAttributes {
  id: string;
  name: string;
  icon: string;
  created_at: string;
  updated_at: string;
}
export class QuestionCategoryModel {
  id: string;
  name: string;
  icon: string;
  created_at: string;
  updated_at: string;

  constructor(input?: QuestionCategoryGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.icon = input ? input.icon : '';
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getCreateAttributes(): QuestionCategorySendAttributes {
    return {
      name: this.name,
      icon: this.icon ? this.icon : '',
    };
  }
  getUpdateAttributes(): QuestionCategorySendAttributes {
    return {
      name: this.name,
      icon: this.icon ? this.icon : '',
    };
  }
}
export const Icons = [
  {
    name: 'app:building_fire',
    label: 'ビル火災',
    keywords: ['災害', '火事'],
  },
  {
    name: 'app:home_fire',
    label: '住家火災',
    keywords: ['災害', '住宅', '火事'],
  },
  { name: 'app:tsunami', label: '津波', keywords: ['災害', '水害'] },
  { name: 'app:earthquake', label: '地震', keywords: ['災害', '震災'] },
  { name: 'app:oil', label: 'オイル' },
  { name: 'app:pointing', label: '確認' },
  { name: 'app:patrol_lamp', label: '防犯' },
  { name: 'app:kerosene', label: '灯油' },
  { name: 'app:truck', label: 'トラック' },
  { name: 'app:ambulance', label: '救急車' },
  { name: 'app:destination', label: '場所' },
  { name: 'app:team', label: 'チーム' },
  { name: 'app:folder', label: 'フォルダ' },
  { name: 'app:paper_pen', label: '書類' },
  { name: 'app:personal_injury', label: '負傷者' },
  { name: 'app:domain', label: 'ビル' },
  { name: 'app:evacuees', label: '避難', keywords: ['災害'] },
  { name: 'app:electrical_plug', label: '電源' },
  { name: 'app:light_bulb', label: '電球' },
  { name: 'app:faucet', label: '水道' },
  { name: 'app:radio_wave', label: '通信' },
  { name: 'app:desktop_pc', label: 'デスクトップPC' },
  { name: 'app:laptop', label: 'ノートPC' },
  { name: 'app:fire', label: '火', keywords: ['災害'] },
  { name: 'app:train', label: '電車' },
  { name: 'app:commute', label: '通勤' },
  { name: 'app:directions_car', label: '自動車' },
  { name: 'app:shopping_cart', label: '買い物' },
  { name: 'app:factory', label: '工場' },
  { name: 'app:speech_bubble', label: 'コメント' },
  { name: 'app:transport_ship', label: '貨物船' },
  { name: 'app:flight', label: '飛行機' },
  { name: 'app:shop', label: '店舗' },
  { name: 'app:local_convenience_store', label: 'コンビニ' },
  { name: 'app:shop2', label: '店舗2' },
  { name: 'app:elevator', label: 'エレベーター' },
  { name: 'app:repairing', label: '修理' },
  { name: 'app:warning', label: '警告' },
  { name: 'app:error', label: 'エラー' },
  { name: 'app:data_alert', label: 'データアラート' },
  { name: 'app:sync_problem', label: '同期エラー' },
  { name: 'app:sms_failed', label: 'システムアラート' },
  { name: 'app:accessibility_new', label: '人' },
  { name: 'app:help', label: 'クエスチョン' },
  { name: 'app:live_help', label: '質問' },
  { name: 'app:liquor', label: '飲食' },
  { name: 'app:restaurant', label: '食事' },
  { name: 'app:fastfood', label: 'ファストフード' },
  { name: 'app:kitchen', label: '冷蔵庫' },
  { name: 'app:microwave_gen', label: '電子レンジ' },
  { name: 'app:marker_atm', label: 'ATM' },
  { name: 'app:desk', label: 'デスク' },
  { name: 'app:shelves', label: '棚・什器' },
  { name: 'app:pet_bottle', label: '備蓄' },
  { name: 'app:toilet', label: 'トイレ' },
  { name: 'app:bullhorn', label: '拡声器' },
  { name: 'app:check_circle', label: 'チェック' },
  { name: 'app:closure_road', label: '工事中・通行止め' },
  { name: 'app:lock', label: 'ロック' },
  { name: 'app:schedule', label: '時間' },
  { name: 'app:calendar_month', label: '日付' },
  { name: 'app:road', label: '道路' },
  { name: 'app:flag', label: '旗' },
  { name: 'app:flood', label: '洪水', keywords: ['災害'] },
  { name: 'app:rainy', label: '雨' },
  { name: 'app:snow', label: '雪' },
  { name: 'app:power_button', label: '電源ボタン' },
  { name: 'app:forklift', label: 'フォークリフト' },
  { name: 'app:front_loader', label: 'ブルドーザー' },
  { name: 'app:conveyor_belt', label: 'ベルトコンベア' },
  { name: 'app:medical_thermometer', label: '体温計' },
  { name: 'app:virus', label: 'ウイルス' },
  { name: 'app:cyclone', label: '低気圧', keywords: ['災害'] },
  { name: 'app:storage', label: 'サーバー' },
  { name: 'app:database', label: 'データベース' },
  { name: 'app:gas_station', label: 'ガソリンスタンド' },
  { name: 'app:oil_field', label: '油田' },
  { name: 'app:solar_panel', label: 'ソーラーパネル' },
  { name: 'app:bacillus', label: 'バイオ' },
  { name: 'app:study', label: '学習塾' },
  { name: 'app:bus', label: 'バス' },
  { name: 'app:cut', label: 'ハサミ' },
  { name: 'app:first_aid_kit', label: '救急箱' },
  { name: 'app:hospital', label: '病院' },
];
